import { Spin } from 'antd';
import * as React from 'react';

import styles from './Loader.module.less';

export const Loader = React.memo(() => (
  <div className={styles.container}>
    <Spin size="large" />
  </div>
));
